import { Card, CardContent } from "@/components/ui/card";
import { Construction, Clock, Sparkles } from "lucide-react";

export default function ComingSoon({ 
  title = "Coming Soon", 
  description = "This feature is currently in development and will be available soon.",
  icon: Icon = Construction,
  iconColor = "text-blue-600",
  estimatedTime = null
}) {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <Card className="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 border-slate-200/60 shadow-xl">
        <CardContent className="p-12">
          <div className="text-center space-y-6">
            {/* Icon */}
            <div className="flex justify-center">
              <div className={`w-24 h-24 rounded-2xl bg-white shadow-lg flex items-center justify-center ${iconColor}`}>
                <Icon className="w-12 h-12" />
              </div>
            </div>

            {/* Title */}
            <h1 className="text-4xl font-bold text-slate-900">
              {title}
            </h1>

            {/* Description */}
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              {description}
            </p>

            {/* Estimated Time */}
            {estimatedTime && (
              <div className="flex items-center justify-center gap-2 text-slate-500">
                <Clock className="w-5 h-5" />
                <span className="text-sm font-medium">
                  Estimated release: {estimatedTime}
                </span>
              </div>
            )}


            {/* Additional Message */}
            <div className="mt-8 p-4 bg-white/60 rounded-lg border border-slate-200/60">
              <div className="flex items-center justify-center gap-2 text-amber-600">
                <Sparkles className="w-5 h-5" />
                <p className="text-sm font-medium">
                  Feature in development
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}